import React from "react";

function MembersCount({ formData }) {
  return (
    <div className="col-lg-2 col-12 px-0 mb-auto" style={{ marginRight: '-1px' }}>
      <div className="card"
        style={{
          borderBottomRightRadius: '0px',
          borderTopRightRadius: '0px',
        }}
      >
        <div className="card-body px-3 py-1">
          <p className="text-xl font-weight-bold text-default mb-0">
            {formData?.members?.count ?? 0}
          </p>
          <span className="text-xs font-weight-bold mb-0">Total Members</span>
        </div>
      </div>
    </div>
  );
}

export default MembersCount;
